import type { Campaign } from 'src/features/admin/campaigns/campaigns.types';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';
import { useInfluencerConfigs } from './use-influencer-additional-configs';

const FOURTY_EIGHT_HOURS_IN_MS = 48 * 60 * 60 * 1000;

export const useInfluencerCampaign = (influencerCampaign?: string, campaignData?: Campaign) => {
  const { campaign } = useActiveCampaign();
  const additionalConfigs = useInfluencerConfigs(campaignData);
  const userFriendlyName = additionalConfigs?.userFriendlyName ?? '';

  const startTime = campaign?.startTime ?? 0;
  const endTime = startTime + FOURTY_EIGHT_HOURS_IN_MS;
  const isExtended = Date.now() > endTime;

  const hoursUntilEnd = (endTime - Date.now()) / (60 * 60 * 1000);
  const shouldIncludeDays = hoursUntilEnd > 24;
  const percentageOff = additionalConfigs?.percentageOff ?? 0;
  return {
    campaign,
    isInInCurrentInfluencerSession: !!influencerCampaign,
    isExtended,
    userFriendlyName,
    shouldIncludeDays,
    calculatedEndTime: endTime,
    percentageOff,
  };
};

export const useInfluencerSubscriptionCampaign = (influencerCampaign?: string, campaignData?: Campaign) => {
  const { campaign } = useActiveCampaign();
  const additionalConfigs = useInfluencerConfigs(campaignData);
  const userFriendlyName = additionalConfigs?.userFriendlyName ?? '';
  const percentageOff = additionalConfigs?.percentageOff ?? 0;

  return {
    campaign,
    isInCurrentInfluencerSession: !!influencerCampaign,
    userFriendlyName,
    percentageOff,
  };
};
